import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ScrollText } from 'lucide-react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-green-100 px-4 py-8">
      <div className="w-full max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-700 mb-8 font-semibold transition-colors">
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <ScrollText className="w-8 h-8 text-indigo-600" />
            <h1 className="text-3xl md:text-4xl font-black text-gray-900">Privacy Policy</h1>
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">1. Information We Collect</h2>
              <p>We collect information you voluntarily provide, including your name, email, phone number, profile photo, and family tree data. We also collect device information and usage analytics to improve the service.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">2. How We Use Your Information</h2>
              <p>Your information is used to provide, maintain, and improve Famitry, to communicate with you, and to personalize your experience. We do not sell your data to third parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">3. Data Storage & Third-Party Services</h2>
              <p>Your data is stored on Google Firebase, a secure cloud platform. We also integrate with Google Sign-In for authentication. Please review Firebase's privacy policy at <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer" className="text-indigo-600 hover:underline">firebase.google.com/support/privacy</a>.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">4. Data Sharing</h2>
              <p>Family tree data is only shared with family members you explicitly invite. We do not share your information with advertisers or third parties without your consent.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">5. Cookies & Tracking</h2>
              <p>We use cookies and analytics tools to understand how you use Famitry. This helps us improve the service and personalize your experience. You can control cookie preferences in your browser settings.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">6. Your Rights</h2>
              <p>You have the right to access, update, or delete your personal data at any time. Contact us at <a href="mailto:admin@famitry.in" className="text-indigo-600 hover:underline">admin@famitry.in</a> to exercise these rights.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">7. Security</h2>
              <p>We implement industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">8. Children's Privacy</h2>
              <p>Famitry is not intended for children under 13. We do not knowingly collect data from children. If we become aware of such collection, we will delete the data immediately.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">9. Policy Changes</h2>
              <p>We may update this Privacy Policy at any time. Continued use of Famitry after changes indicates your acceptance of the updated policy.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">10. Contact Us</h2>
              <p>For privacy-related questions or concerns, contact us at <a href="mailto:admin@famitry.in" className="text-indigo-600 hover:underline">admin@famitry.in</a>.</p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="inline-block px-8 py-3 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 transition-colors">
              Return Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
